// Action types, inspired by Jisse Reitsma's Apollo Playground
const _REDUCE_OPTIONS = "jola/product/_REDUCE_OPTIONS";

export default {
  _REDUCE_OPTIONS
};
